import { desktopFuncNames } from '../../constants/desktop';
import invokeDesktopFunction from './invokeDesktopFunction';

export default function registerDesktopHandler(
  handlerName: string,
  handlerFunction: (...args: unknown[]) => unknown,
) {
  const bridge = window.Bridge;

  if (!bridge) {
    return;
  }

  if (bridge[desktopFuncNames.registerAppHandlers]) {
    invokeDesktopFunction(desktopFuncNames.registerAppHandlers, {
      [handlerName]: handlerFunction,
    });
    return;
  }

  // fallback to directly setting on the Bridge object for older versions of gemini-desktop
  bridge[handlerName] = handlerFunction;
}
